export default "__VITE_ASSET__DHcSYZSv__"